import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { DistrictInChargeAxios } from "api/DistrictInChargeAxios";
import { ProcurementAxios } from "api/ProcurementAxios";

export const fetchDistrictInchargeInstock = createAsyncThunk(
  "DistrictIncharge/fetchInstock",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }
    const response: any = await DistrictInChargeAxios.get(
      `/district_incharge_inventory/list_in_stock/?${params.toString()}`
    );

    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const exportCSVInstock = createAsyncThunk(
  "aprovedpr/exportCSVInstock ",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };
      const response = await ProcurementAxios.get(
        "/approved-pr/list/?export=csv",
        {
          headers,
          responseType: "blob",
        }
      );
      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") || "Aproved PR.csv",
      };
    } catch (err: any) {
      console.error("Export CSV error:", err);
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);

export const fetchAllDropdownsInstock = createAsyncThunk(
  "suppliers/fetchAllDropdownsInstock",
  async (column: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`purchase_request/dropdown/`, {
        params: { columns: column },
      });

      const dropdownData = response.data?.data || response.data || [];

      return { column, data: dropdownData };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch dropdown");
    }
  }
);
